"use client";

// Re-export from the new location
export { PostHogPageView } from "../consent-manager/integrations/page-view";
